// extracted by mini-css-extract-plugin
export var bigPopup = "bigPopup-module--bigPopup--Igd88";
export var close = "bigPopup-module--close--DRk-Y";
export var wrapCenter = "bigPopup-module--wrapCenter--IyU9-";
export var title = "bigPopup-module--title--hpeFJ";
export var tags = "bigPopup-module--tags--oVMCX";
export var tag = "bigPopup-module--tag--R-4Vq";
export var lid = "bigPopup-module--lid--BQPCv";
export var cards = "bigPopup-module--cards--aOw5N";
export var footer = "bigPopup-module--footer--dJdJ1";